<template>
<div  class="container-fluid" >



<div class="card border-primary ">
    <div class="card-header bg-primary text-white">  
      
        <h4>
           <i class="fas fa-label  mr-2" aria-hidden="true"></i>
          LISTINO CLUB
        </h4>
    </div>

    <div v-if="company.Id == 1" class="card-body"> 
       
    <div class="table-responsive">
       <table  class="table table-hover table-fixed table-sm mb-4" id="table">
        <thead >
        <tr>
          <th>#</th>   
          <th>PREZZO DI LISTINO</th>             
          <th>PREZZO SAPIA CLUB</th>   
          
          <th ></th>
        </tr>
        </thead>
        <tbody >
        
        <tr   @dblclick.ctrl="openItem(index)"  data-toggle="tooltip" title="doppio click modifica" :class="`index-${index}`" v-for="(item, index)  in pricesList" :key="index">
          
          <td>{{index+1}}</td> 
           

           
          <td v-if="!isOpen[index]">              
              {{item.retailPrice}}
           </td>

           <td v-else>           
            <input v-focus   v-model = "item.retailPrice" class="form-control bold"  v-bind:id="'id_' + index " type="number">            
          </td>
          
          <td v-if="!isOpen[index]">{{item.clubPrice}}</td> 
          <td v-else>
            <input   v-model = "item.clubPrice"  class="form-control bold"  v-bind:id="'id_' + index " type="number"> 
          </td> 

          
          <td v-if="isOpen[index]">
            <button @click="updateData(item)" type="button"  class="btn btn-primary ">
              <i class="fas fa-save mr-2" aria-hidden="true"></i>
              SALVA
            </button>  
          </td>
          
          
        </tr>

        
        </tbody>
      </table>
    </div>


    <alert-box class="mt-4" @close="msg.title=''" v-bind:msg="msg"  ></alert-box> 

    <!--<strong>Filtra colore</strong> <input class="form-control" type="text"  v-model="filterKey">  -->
  
    
    </div>




 <div class="card-footer">
  

  <div >

  </div> 


  
  </div>

</div>
  


</div>    
</template>
<script>
import { mapGetters }    from 'vuex';

import api               from '@/api'
import alertBox          from '@/components/common/AlertBox.vue'

import SapiaClub          from '@/components/mixins/SapiaClub.js'


export default {
  components: {alertBox,SapiaClub},
  mixins    : [SapiaClub],
  props: [''],
  data () {
    return {

       

        spinner         : false,        
        items           : [],       
        isOpen          : [],
    
        msg             : {title : '',body:'',type :0},
        
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },  
computed: 
  {
    ...mapGetters(['company']),
   
  },
mounted()
    {   
      
        
    },
created()
{
   this.getSapiaClubPricesList()
},    
methods: 
{ 
    openItem(index)
    {
      
      this.msg.title = ''
      for (let i = 0; i < this.isOpen.length; i++) {
        this.$set(this.isOpen,i,false)      
      }
      this.$set(this.isOpen,index,true) 
      
      
     
    },
    closeItems()
    {
      for (let i = 0; i < this.isOpen.length; i++) {
        this.$set(this.isOpen,i,false)      
      }
    },
   
    
    updateData(item)
    {
        console.log(item)
        
        if(!item.retailPrice)            
        {
          return
        } 
        if(!item.clubPrice)            
        {
          return
        } 
       
       
       

        const sp   = {'sp':'spUpdateSapiaClubPricesList'}
        
        const json = Object.assign(item, sp)    

        api.post(json).then(res => {
          if(res.status==200)
            {
                            
              
              this.msg.title = 'AGGIORNAMENTO EFFETTUATO.'
              this.msg.body = ''
              this.msg.type = 0   
              this.closeItems()

              
                                             
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                      
            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                      
            } 
        }).catch(err => 
        {
          

              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                      
          

        }).finally(() => {
          this.spinner = false
        });
  


    },

    
}    
  
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
 .my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }

  .table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;
    position     : sticky;
    top          : 0;
    z-index      : 10;
  

 }
 .table-hover:hover
{
  cursor: pointer;
}

.bold{
  font-weight: bold;
}
td:nth-child(3) {
                width: 30%;
            }
</style>